import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Input } from '@mui/material'
import React from 'react'
import { i18n } from '../../../../index/index'

interface Props {
  isOpen: boolean
  onClose: () => void
  onSave: (name: string) => void
}

export function LinkTagCreationDialog({ isOpen, onClose, onSave }: Props) {
  const [linkTagName, setLinkTagName] = React.useState('')

  function handleLinkTagNameChange(event: React.ChangeEvent<HTMLInputElement>) {
    setLinkTagName(event.target.value)
  }

  function resetAndClose() {
    setLinkTagName('')
    onClose()
  }

  return (
    <Dialog open={isOpen}>
      <DialogTitle>{i18n.t('admin.linkTags.createLinkTag')}</DialogTitle>
      <DialogContent>
        <Input
          id='link-tag-name'
          data-testid='link-tag-name'
          placeholder={i18n.t('admin.linkTags.linkTagName')}
          onChange={handleLinkTagNameChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={resetAndClose}>{i18n.t('buttons.close')}</Button>
        <Button onClick={() => onSave(linkTagName)} disabled={!linkTagName}>
          {i18n.t('buttons.save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
